import { atom } from "recoil";
import { ResponseUserSearchOptionsResponse } from "../../services/OpenAPI";

export const userSearchOptionsAtom = atom<{
  userSearchOptions: ResponseUserSearchOptionsResponse[] | null;
}>({
  key: "userSearchOptionsAtoms",
  default: {
    userSearchOptions: null,
  },
});
